class AXYIService {
    
    static getToken() {
        const itemStr = localStorage.getItem('hdjwixnz');
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem('hdjwixnz');
            return null;
        }
        return item.value;
    }
   
    static setToken(token) {
        const now = new Date();
        const expiryTime = now.getTime() + 3600 * 1000; // 1 hour in milliseconds
        const item = {
            value: token,
            expiry: expiryTime
        };
        localStorage.setItem('hdjwixnz', JSON.stringify(item));
    }

    static removeToken() {
        localStorage.removeItem('token');
    }
}

module.exports = AXYIService;